import clsx from 'clsx';
import CustomCheckbox from './CustomCheckBox';
import { useFidCardFunnelTracking } from '../../../../../posthog/funnelTrackingFidCard';
import { useEffect } from 'react';

const OptinStep = ({
                     emailOptin = false,
                     smsOptin = false,
                     onEmailOptinChange,
                     onSmsOptinChange,
                     showEmailOptin = true,
                     showSmsOptin = true,
                     className = '',
                     emailLabel,
                     smsLabel,
                   }) => {
  const defaultEmailLabel =
    'J’accepte de recevoir par email les offres et actualités de Match et de ses partenaires.';
  const defaultSmsLabel =
    'J’accepte de recevoir par SMS les offres et actualités de Match et de ses partenaires.';

  const { trackPageViewCreateEmail } = useFidCardFunnelTracking();

  useEffect(() => {
    trackPageViewCreateEmail({});
  }, []);

  return (
    <div className={clsx('space-y-4 ml-2', className)}>
      {showEmailOptin && (
        <CustomCheckbox
          id="email-optin"
          checked={emailOptin}
          onChange={onEmailOptinChange}
          label={emailLabel || defaultEmailLabel}
        />
      )}

      {showSmsOptin && (
        <CustomCheckbox
          id="sms-optin"
          checked={smsOptin}
          onChange={onSmsOptinChange}
          label={smsLabel || defaultSmsLabel}
        />
      )}
    </div>
  );
};

export default OptinStep;
